<template>
  <div class="small-rounded-btn edit">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.74"
      height="19.756"
      viewBox="0 0 19.74 19.756"
    >
      <path
        id="Pfad_69"
        data-name="Pfad 69"
        d="M802.441,92.28a1.341,1.341,0,0,1-.4.944q-3.991,4-7.986,7.991-1.083,1.083-2.166,2.166-1.227,1.223-2.46,2.44a1.267,1.267,0,0,1-.4.263q-2.747,1.1-5.5,2.19a.419.419,0,0,1-.366-.024.434.434,0,0,1,0-.367c.513-1.282,1.038-2.559,1.561-3.837.1-.255.225-.5.311-.764a4.243,4.243,0,0,1,1.248-1.882c.867-.776,1.644-1.652,2.468-2.477q4.707-4.714,9.42-9.422a1.4,1.4,0,0,1,2.116,0c.567.561,1.128,1.13,1.695,1.691A1.459,1.459,0,0,1,802.441,92.28Zm-13.5,12.577,10.7-10.706-2.278-2.307-10.726,10.714Zm11.523-11.5c.273-.279.547-.554.815-.834a.365.365,0,0,0-.008-.567c-.59-.594-1.175-1.194-1.785-1.768a.481.481,0,0,0-.453-.065c-.327.282-.61.615-.891.91Zm-14.388,10.057-1.331,3.269,3.312-1.32Z"
        transform="translate(-782.901 -88.764)"
        fill="rgba(221,112,3,0.87)"
        stroke="rgba(221,112,3,0.87)"
        stroke-width="0.4"
      />
    </svg>
  </div>
</template>
